module.exports = __webpack_public_path__ + "img/xnkl.82701e8a.jpg";